import React from 'react';

import LogoImage from '../../assets/Logo.svg';
import { LoaderSVG, Logo, Overlay } from './styles';

const Loader = () => {
  return (
    <Overlay className="overlay-loading">
      <div style={{ position: 'relative' }}>
        <LoaderSVG
          width="100"
          height="100"
          viewBox="0 0 37 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.0819 17H3.02508C1.91076 17 1.01376 17.9059 1.0485 19.0197C1.15761 22.5177 1.49703 29.7374 2.5 34C4.07125 40.6778 7.18553 44.8868 8.44856 46.3845C8.79051 46.79 9.29799 47 9.82843 47H20.0218C20.639 47 21.2193 46.7159 21.5659 46.2052C22.6765 44.5687 25.2312 40.4282 27.5 34C28.9757 29.8188 29.084 22.4043 29.0441 18.9156C29.0319 17.8436 28.1539 17 27.0819 17Z"
            stroke="#00B35C"
            strokeWidth="2"
          />
          <path
            d="M29 23.5C29 23.5 34.5 20.5 35.5 25.4999C36.0986 28.4926 34.2033 31.5383 32 32.8713C29.4555 34.4108 28 34 28 34"
            stroke="#00b35b"
            strokeWidth="2"
          />
          <path
            id="steamL"
            d="M17 1C17 1 17 4.5 14 6.5C11 8.5 11 12 11 12"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#c0c0c0"
          />
          <path
            id="steamR"
            d="M21 6C21 6 21 8.22727 19 9.5C17 10.7727 17 13 17 13"
            stroke="#c0c0c0"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </LoaderSVG>
        <Logo src={LogoImage} />
      </div>
    </Overlay>
  );
};

export default Loader;
